import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Bling as Slider } from 'react-gpt'

Slider.configure({
  renderWhenViewable: false,
  collapseEmptyDiv: true,
  outOfPage: true
})

class AdSlider extends Component {
  componentWillMount () {
    this.urlSlider = '/' + this.props.accountDfp + '/' + this.props.sliderName
    this.setState({ sliderPosition: this.props.sliderPosition })
  }
  componentDidMount () {
    /* eslint-disable */
    setInterval(() => {
      this.nextSlide()
    }, 7000)
     /* eslint-enable */
  }
/* eslint-disable */
  nextSlide = () => {
    jQuery('.csslider input[type="radio"]').each(function(b, e) {
      jQuery(e).is(":checked") && (b + 1 == jQuery('.csslider input[type="radio"]').length ? setTimeout(function() {
          jQuery('.csslider input[type="radio"]:eq(0)').trigger("click")
      }, 5000) : setTimeout(function() {
          jQuery(e).next().trigger("click")
      }, 5000))
  });
  }
  removeEmpty = event => {
    if (event.isEmpty) {
      jQuery(`.${this.state.sliderPosition}`).remove()
    } else {
      setTimeout(() => {
        this.props.sendSliderLoaded(this.state.sliderPosition)
      }, 1000)

      if (jQuery('.csslider .navigation.d-none').length > 0) {
        setTimeout(() => {
          jQuery('.csslider .navigation').removeClass('d-none').addClass('d-block')
        }, 3000)
      }
    }

    if (jQuery('.cssslider-container li.scrollable').length == 0) {
      jQuery('.container-slider').remove()
    }
    if (jQuery('.cssslider-container li.scrollable').length <= 2) {
      jQuery('.container-slider .arrows').remove();
    }
  }
  /* eslint-enable */

  render () {
    return (
      <Slider
        adUnitPath={this.urlSlider}
        targeting={this.props.targeting}
        sizeMapping={
          this.props.sizeMapping
        }
        onSlotRenderEnded={this.removeEmpty}
      />
    )
  }
}

AdSlider.propTypes = {
  accountDfp: PropTypes.string.isRequired,
  sliderName: PropTypes.string.isRequired,
  targeting: PropTypes.any,
  sizeMapping: PropTypes.array,
  sliderPosition: PropTypes.string,
  sendSliderLoaded: PropTypes.func
}

export default AdSlider



// WEBPACK FOOTER //
// ./src/features/Slider/AdSlider.js